import React, {Component} from "react";
import PropTypes from "prop-types";
import {setAuthState} from "../../../../services/AuthServices";
import {Redirect} from "react-router-dom";
import {_getProfile} from "../../../../services/apis/UserServices";

class AuthPage extends Component {
    state = {
        success: false,
        error: ''
    };

    componentDidMount() {
        const {match} = this.props;
        const {token} = match.params;

        setAuthState({
            accessToken: token
        })
        this.setState({
            success: true
        })

        // this._fetchUserProfile();
    }

    _fetchUserProfile = () => {
        return _getProfile()
            .then(response => {
                const {data, success, message} = response;

                if (success) {
                    setAuthState({
                        user: data
                    });

                    this.setState({
                        success: true
                    });
                } else {
                    this.setState({
                        error: message
                    });
                }
            });
    };

    render() {
        const {success, error} = this.state;

        if (success) {
            return <Redirect to="/"/>;
        }

        return (
            <div className="AuthPage">
                {
                    error ? error : 'Loading..'
                }
            </div>
        );
    }
}

AuthPage.propTypes = {
    history: PropTypes.object
};

export default AuthPage;


// WEBPACK FOOTER //
// ./src/app/pages/auth/AuthPage/AuthPage.js